import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import React, { useEffect } from 'react';

import { setDeviceOSView } from 'redux/UiEffects/actions';
import { selectConfig } from 'redux/Onboadring/selectors';

import styles from './PreloadTestania.module.css';

import withSetLocalizationFromParams from 'hocs/Localization/withSetLocalizationFromParams';

const PreloadTestania = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setDeviceOSView());
    }, []);

    return <div className={styles.container} />;
};

const mapStateToProps = (state) => {
    return {
        config: selectConfig(state),
    };
};

export default compose(withSetLocalizationFromParams, connect(mapStateToProps))(PreloadTestania);
